import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CareEventDiagnosisFragment = { readonly __typename?: 'VisitCareEvent', readonly diagnosisList?: ReadonlyArray<{ readonly __typename?: 'Diagnosis', readonly type?: Types.DiagnosisType | null, readonly uuid?: string | null, readonly notes?: string | null, readonly diseaseSnapshot?: unknown | null } | null> | null };

export type InpatientLocationFragment = { readonly __typename?: 'VisitLocationSnapshot', readonly _id: string, readonly name: string, readonly created?: string | null, readonly color?: string | null, readonly performer?: string | null };

export type VisitByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type VisitByIdQuery = { readonly __typename?: 'Query', readonly visitById?: { readonly __typename?: 'Visit', readonly _id: string, readonly isCurrent?: boolean | null, readonly currentLocation?: { readonly __typename?: 'VisitLocationSnapshot', readonly _id: string, readonly name: string } | null, readonly currentDepartment?: { readonly __typename?: 'VisitDepartmentSnapshot', readonly _id: string, readonly title: string } | null, readonly admissionEvent?: { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly created?: string | null, readonly notes?: string | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly name: string } | null, readonly diagnosisList?: ReadonlyArray<{ readonly __typename?: 'Diagnosis', readonly type?: Types.DiagnosisType | null, readonly uuid?: string | null, readonly notes?: string | null, readonly diseaseSnapshot?: unknown | null } | null> | null } | null, readonly dischargeEvent?: { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly created?: string | null, readonly outcome?: Types.DischargeOutcome | null, readonly notes?: string | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly name: string } | null, readonly diagnosisList?: ReadonlyArray<{ readonly __typename?: 'Diagnosis', readonly type?: Types.DiagnosisType | null, readonly uuid?: string | null, readonly notes?: string | null, readonly diseaseSnapshot?: unknown | null } | null> | null } | null, readonly inpatientLocations?: ReadonlyArray<{ readonly __typename?: 'VisitLocationSnapshot', readonly _id: string, readonly name: string, readonly created?: string | null, readonly color?: string | null, readonly performer?: string | null } | null> | null, readonly inpatientDepartments?: ReadonlyArray<{ readonly __typename?: 'VisitDepartmentSnapshot', readonly _id: string, readonly title: string, readonly careEventCreatedAt?: string | null, readonly performer?: string | null } | null> | null } | null };

export type GetVisitNotesQueryVariables = Types.Exact<{
  input: Types.VisitWithFilteredNotesInput;
}>;


export type GetVisitNotesQuery = { readonly __typename?: 'Query', readonly visitWithFilteredNotes?: { readonly __typename?: 'Visit', readonly _id: string, readonly careEvents: ReadonlyArray<{ readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly created?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly notes?: string | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string, readonly role?: string | null } | null } | null> } | null };

export type UpdateInpatientLocationMutationVariables = Types.Exact<{
  input: Types.UpdateInpatientLocationInput;
}>;


export type UpdateInpatientLocationMutation = { readonly __typename?: 'Mutation', readonly updateInpatientLocation?: { readonly __typename?: 'Visit', readonly _id: string, readonly inpatientLocations?: ReadonlyArray<{ readonly __typename?: 'VisitLocationSnapshot', readonly _id: string, readonly name: string, readonly created?: string | null, readonly color?: string | null, readonly performer?: string | null } | null> | null } | null };

export type UpdateInpatientDepartmentMutationVariables = Types.Exact<{
  input: Types.UpdateInpatientDepartmentInput;
}>;


export type UpdateInpatientDepartmentMutation = { readonly __typename?: 'Mutation', readonly updateInpatientDepartment?: { readonly __typename?: 'Visit', readonly _id: string, readonly inpatientDepartments?: ReadonlyArray<{ readonly __typename?: 'VisitDepartmentSnapshot', readonly _id: string, readonly title: string, readonly careEventCreatedAt?: string | null } | null> | null } | null };

export type AddNoteMutationVariables = Types.Exact<{
  input: Types.AddNoteToVisitInput;
}>;


export type AddNoteMutation = { readonly __typename?: 'Mutation', readonly addNoteToCurrentVisit?: { readonly __typename?: 'Visit', readonly _id: string, readonly careEvents: ReadonlyArray<{ readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly created?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly notes?: string | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string, readonly role?: string | null } | null } | null> } | null };

export type InvestigationCareEventFragment = { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly created?: string | null, readonly investigationActivity?: { readonly __typename?: 'VisitInvestigationActivity', readonly _id: string, readonly void: boolean, readonly meta: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null }, readonly catalogueItem: { readonly __typename?: 'VisitInvestigationActivityItem', readonly _id?: string | null, readonly title?: string | null, readonly activityType: string, readonly keywords?: ReadonlyArray<string | null> | null, readonly coding?: { readonly __typename?: 'VisitCatalogueCoding', readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string } | null } | null, readonly result?: { readonly __typename?: 'VisitInvestigationItemResult', readonly resultSchema: unknown } | null, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null }, readonly request?: { readonly __typename?: 'VisitInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly performer: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string }, readonly organisation: { readonly __typename?: 'VisitFacilitySnapshot', readonly uuid: string, readonly name: string }, readonly clinic: { readonly __typename?: 'VisitFacilitySnapshot', readonly _id?: string | null, readonly uuid: string, readonly name: string } } | null, readonly outcome?: { readonly __typename?: 'VisitInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly performer: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string }, readonly organisation: { readonly __typename?: 'VisitFacilitySnapshot', readonly uuid: string, readonly name: string }, readonly clinic: { readonly __typename?: 'VisitFacilitySnapshot', readonly _id?: string | null, readonly uuid: string, readonly name: string } } | null } | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string } | null };

export type GetVisitInvestigationsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetVisitInvestigationsQuery = { readonly __typename?: 'Query', readonly visitById?: { readonly __typename?: 'Visit', readonly _id: string, readonly isCurrent?: boolean | null, readonly careEvents: ReadonlyArray<{ readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly created?: string | null, readonly investigationActivity?: { readonly __typename?: 'VisitInvestigationActivity', readonly _id: string, readonly void: boolean, readonly meta: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null }, readonly catalogueItem: { readonly __typename?: 'VisitInvestigationActivityItem', readonly _id?: string | null, readonly title?: string | null, readonly activityType: string, readonly keywords?: ReadonlyArray<string | null> | null, readonly coding?: { readonly __typename?: 'VisitCatalogueCoding', readonly loinc?: { readonly __typename?: 'SpecificationReference', readonly code: string } | null } | null, readonly result?: { readonly __typename?: 'VisitInvestigationItemResult', readonly resultSchema: unknown } | null, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null }, readonly request?: { readonly __typename?: 'VisitInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly performer: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string }, readonly organisation: { readonly __typename?: 'VisitFacilitySnapshot', readonly uuid: string, readonly name: string }, readonly clinic: { readonly __typename?: 'VisitFacilitySnapshot', readonly _id?: string | null, readonly uuid: string, readonly name: string } } | null, readonly outcome?: { readonly __typename?: 'VisitInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly performer: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string }, readonly organisation: { readonly __typename?: 'VisitFacilitySnapshot', readonly uuid: string, readonly name: string }, readonly clinic: { readonly __typename?: 'VisitFacilitySnapshot', readonly _id?: string | null, readonly uuid: string, readonly name: string } } | null } | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string } | null } | null> } | null };

export type PrintInpatientSummaryQueryVariables = Types.Exact<{
  uuid: Types.Scalars['String'];
  searchWholeTerritory?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type PrintInpatientSummaryQuery = { readonly __typename?: 'Query', readonly patientByCardId?: { readonly __typename?: 'PatientByCardIdResult', readonly passportId?: string | null, readonly patient: { readonly __typename?: 'Patient', readonly uuid: string, readonly card?: { readonly __typename?: 'PatientCard', readonly id?: string | null } | null, readonly person: { readonly __typename?: 'Person', readonly dob: string, readonly gender: Types.Gender, readonly name: { readonly __typename?: 'Name', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null } } } } | null };

export type GetInpatientInvestigationsMedicinesQueryVariables = Types.Exact<{
  visitId: Types.Scalars['ID'];
}>;


export type GetInpatientInvestigationsMedicinesQuery = { readonly __typename?: 'Query', readonly visitById?: { readonly __typename?: 'Visit', readonly _id: string, readonly investigations: ReadonlyArray<{ readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly investigationActivity?: { readonly __typename?: 'VisitInvestigationActivity', readonly _id: string, readonly meta: { readonly __typename?: 'Meta', readonly created?: string | null }, readonly catalogueItem: { readonly __typename?: 'VisitInvestigationActivityItem', readonly _id?: string | null, readonly title?: string | null, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null } | null }, readonly request?: { readonly __typename?: 'VisitInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly performer: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string } } | null, readonly outcome?: { readonly __typename?: 'VisitInvestigationRequestOutcome', readonly orderedProperties: ReadonlyArray<unknown | null>, readonly performer: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string } } | null } | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string } | null } | null>, readonly inpatientMedicineAdministered?: ReadonlyArray<{ readonly __typename?: 'VisitMedicineAdministered', readonly skuId: string, readonly skuName?: string | null, readonly created?: string | null, readonly prescriber?: string | null, readonly dosageValue?: number | null, readonly dosageUnit?: string | null, readonly totalAdministeredQuantity?: number | null } | null> | null } | null };

export const CareEventDiagnosisFragmentDoc = gql`
    fragment CareEventDiagnosis on VisitCareEvent {
  diagnosisList {
    type
    uuid
    notes
    diseaseSnapshot
  }
}
    `;
export const InpatientLocationFragmentDoc = gql`
    fragment InpatientLocation on VisitLocationSnapshot {
  _id
  name
  created
  color
  performer
}
    `;
export const InvestigationCareEventFragmentDoc = gql`
    fragment InvestigationCareEvent on VisitCareEvent {
  _id
  type
  created
  investigationActivity {
    _id
    void
    meta {
      created
      updated
    }
    catalogueItem {
      _id
      title
      activityType
      coding {
        loinc {
          code
        }
      }
      keywords
      result {
        resultSchema
      }
      meta {
        created
        updated
      }
    }
    request {
      performer {
        _id
        name
      }
      organisation {
        uuid
        name
      }
      clinic {
        _id
        uuid
        name
      }
      orderedProperties
    }
    outcome {
      performer {
        _id
        name
      }
      organisation {
        uuid
        name
      }
      clinic {
        _id
        uuid
        name
      }
      orderedProperties
    }
  }
  performer {
    _id
    name
  }
}
    `;
export const VisitByIdDocument = gql`
    query VisitById($id: ID!) {
  visitById(id: $id) {
    _id
    isCurrent
    currentLocation {
      _id
      name
    }
    currentDepartment {
      _id
      title
    }
    admissionEvent {
      _id
      type
      created
      notes
      performer {
        name
      }
      ...CareEventDiagnosis
    }
    dischargeEvent {
      _id
      type
      created
      outcome
      notes
      performer {
        name
      }
      ...CareEventDiagnosis
    }
    inpatientLocations {
      ...InpatientLocation
    }
    inpatientDepartments {
      _id
      title
      careEventCreatedAt
      performer
    }
  }
}
    ${CareEventDiagnosisFragmentDoc}
${InpatientLocationFragmentDoc}`;

/**
 * __useVisitByIdQuery__
 *
 * To run a query within a React component, call `useVisitByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVisitByIdQuery(baseOptions: Apollo.QueryHookOptions<VisitByIdQuery, VisitByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitByIdQuery, VisitByIdQueryVariables>(VisitByIdDocument, options);
      }
export function useVisitByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitByIdQuery, VisitByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitByIdQuery, VisitByIdQueryVariables>(VisitByIdDocument, options);
        }
export type VisitByIdQueryHookResult = ReturnType<typeof useVisitByIdQuery>;
export type VisitByIdLazyQueryHookResult = ReturnType<typeof useVisitByIdLazyQuery>;
export type VisitByIdQueryResult = Apollo.QueryResult<VisitByIdQuery, VisitByIdQueryVariables>;
export const GetVisitNotesDocument = gql`
    query getVisitNotes($input: VisitWithFilteredNotesInput!) {
  visitWithFilteredNotes(input: $input) {
    _id
    careEvents {
      _id
      created
      type
      notes
      performer {
        _id
        name
        role
      }
    }
  }
}
    `;

/**
 * __useGetVisitNotesQuery__
 *
 * To run a query within a React component, call `useGetVisitNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitNotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVisitNotesQuery(baseOptions: Apollo.QueryHookOptions<GetVisitNotesQuery, GetVisitNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitNotesQuery, GetVisitNotesQueryVariables>(GetVisitNotesDocument, options);
      }
export function useGetVisitNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitNotesQuery, GetVisitNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitNotesQuery, GetVisitNotesQueryVariables>(GetVisitNotesDocument, options);
        }
export type GetVisitNotesQueryHookResult = ReturnType<typeof useGetVisitNotesQuery>;
export type GetVisitNotesLazyQueryHookResult = ReturnType<typeof useGetVisitNotesLazyQuery>;
export type GetVisitNotesQueryResult = Apollo.QueryResult<GetVisitNotesQuery, GetVisitNotesQueryVariables>;
export const UpdateInpatientLocationDocument = gql`
    mutation updateInpatientLocation($input: UpdateInpatientLocationInput!) {
  updateInpatientLocation(input: $input) {
    _id
    inpatientLocations {
      ...InpatientLocation
    }
  }
}
    ${InpatientLocationFragmentDoc}`;
export type UpdateInpatientLocationMutationFn = Apollo.MutationFunction<UpdateInpatientLocationMutation, UpdateInpatientLocationMutationVariables>;

/**
 * __useUpdateInpatientLocationMutation__
 *
 * To run a mutation, you first call `useUpdateInpatientLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInpatientLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInpatientLocationMutation, { data, loading, error }] = useUpdateInpatientLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInpatientLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInpatientLocationMutation, UpdateInpatientLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInpatientLocationMutation, UpdateInpatientLocationMutationVariables>(UpdateInpatientLocationDocument, options);
      }
export type UpdateInpatientLocationMutationHookResult = ReturnType<typeof useUpdateInpatientLocationMutation>;
export type UpdateInpatientLocationMutationResult = Apollo.MutationResult<UpdateInpatientLocationMutation>;
export type UpdateInpatientLocationMutationOptions = Apollo.BaseMutationOptions<UpdateInpatientLocationMutation, UpdateInpatientLocationMutationVariables>;
export const UpdateInpatientDepartmentDocument = gql`
    mutation updateInpatientDepartment($input: UpdateInpatientDepartmentInput!) {
  updateInpatientDepartment(input: $input) {
    _id
    inpatientDepartments {
      _id
      title
      careEventCreatedAt
    }
  }
}
    `;
export type UpdateInpatientDepartmentMutationFn = Apollo.MutationFunction<UpdateInpatientDepartmentMutation, UpdateInpatientDepartmentMutationVariables>;

/**
 * __useUpdateInpatientDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateInpatientDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInpatientDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInpatientDepartmentMutation, { data, loading, error }] = useUpdateInpatientDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInpatientDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInpatientDepartmentMutation, UpdateInpatientDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInpatientDepartmentMutation, UpdateInpatientDepartmentMutationVariables>(UpdateInpatientDepartmentDocument, options);
      }
export type UpdateInpatientDepartmentMutationHookResult = ReturnType<typeof useUpdateInpatientDepartmentMutation>;
export type UpdateInpatientDepartmentMutationResult = Apollo.MutationResult<UpdateInpatientDepartmentMutation>;
export type UpdateInpatientDepartmentMutationOptions = Apollo.BaseMutationOptions<UpdateInpatientDepartmentMutation, UpdateInpatientDepartmentMutationVariables>;
export const AddNoteDocument = gql`
    mutation addNote($input: AddNoteToVisitInput!) {
  addNoteToCurrentVisit(input: $input) {
    _id
    careEvents {
      _id
      created
      type
      notes
      performer {
        _id
        name
        role
      }
    }
  }
}
    `;
export type AddNoteMutationFn = Apollo.MutationFunction<AddNoteMutation, AddNoteMutationVariables>;

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteMutation, AddNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument, options);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult = Apollo.MutationResult<AddNoteMutation>;
export type AddNoteMutationOptions = Apollo.BaseMutationOptions<AddNoteMutation, AddNoteMutationVariables>;
export const GetVisitInvestigationsDocument = gql`
    query getVisitInvestigations($id: ID!) {
  visitById(id: $id) {
    _id
    isCurrent
    careEvents(
      input: {types: [INVESTIGATION_REQUEST, INVESTIGATION_OUTCOME, INVESTIGATION_RESULTS]}
    ) {
      ...InvestigationCareEvent
    }
  }
}
    ${InvestigationCareEventFragmentDoc}`;

/**
 * __useGetVisitInvestigationsQuery__
 *
 * To run a query within a React component, call `useGetVisitInvestigationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitInvestigationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitInvestigationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVisitInvestigationsQuery(baseOptions: Apollo.QueryHookOptions<GetVisitInvestigationsQuery, GetVisitInvestigationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitInvestigationsQuery, GetVisitInvestigationsQueryVariables>(GetVisitInvestigationsDocument, options);
      }
export function useGetVisitInvestigationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitInvestigationsQuery, GetVisitInvestigationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitInvestigationsQuery, GetVisitInvestigationsQueryVariables>(GetVisitInvestigationsDocument, options);
        }
export type GetVisitInvestigationsQueryHookResult = ReturnType<typeof useGetVisitInvestigationsQuery>;
export type GetVisitInvestigationsLazyQueryHookResult = ReturnType<typeof useGetVisitInvestigationsLazyQuery>;
export type GetVisitInvestigationsQueryResult = Apollo.QueryResult<GetVisitInvestigationsQuery, GetVisitInvestigationsQueryVariables>;
export const PrintInpatientSummaryDocument = gql`
    query PrintInpatientSummary($uuid: String!, $searchWholeTerritory: Boolean) {
  patientByCardId(uuid: $uuid, searchWholeTerritory: $searchWholeTerritory) {
    passportId
    patient {
      uuid
      card {
        id
      }
      person {
        name {
          firstname
          middlename
          lastname
        }
        dob
        gender
      }
    }
  }
}
    `;

/**
 * __usePrintInpatientSummaryQuery__
 *
 * To run a query within a React component, call `usePrintInpatientSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintInpatientSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintInpatientSummaryQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      searchWholeTerritory: // value for 'searchWholeTerritory'
 *   },
 * });
 */
export function usePrintInpatientSummaryQuery(baseOptions: Apollo.QueryHookOptions<PrintInpatientSummaryQuery, PrintInpatientSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintInpatientSummaryQuery, PrintInpatientSummaryQueryVariables>(PrintInpatientSummaryDocument, options);
      }
export function usePrintInpatientSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintInpatientSummaryQuery, PrintInpatientSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintInpatientSummaryQuery, PrintInpatientSummaryQueryVariables>(PrintInpatientSummaryDocument, options);
        }
export type PrintInpatientSummaryQueryHookResult = ReturnType<typeof usePrintInpatientSummaryQuery>;
export type PrintInpatientSummaryLazyQueryHookResult = ReturnType<typeof usePrintInpatientSummaryLazyQuery>;
export type PrintInpatientSummaryQueryResult = Apollo.QueryResult<PrintInpatientSummaryQuery, PrintInpatientSummaryQueryVariables>;
export const GetInpatientInvestigationsMedicinesDocument = gql`
    query getInpatientInvestigationsMedicines($visitId: ID!) {
  visitById(id: $visitId) {
    _id
    investigations: careEvents(
      input: {types: [INVESTIGATION_OUTCOME, INVESTIGATION_RESULTS]}
    ) {
      _id
      type
      investigationActivity {
        _id
        meta {
          created
        }
        catalogueItem {
          _id
          title
          meta {
            created
          }
        }
        request {
          performer {
            _id
            name
          }
          orderedProperties
        }
        outcome {
          performer {
            _id
            name
          }
          orderedProperties
        }
      }
      performer {
        _id
        name
      }
    }
    inpatientMedicineAdministered {
      skuId
      skuName
      created
      prescriber
      dosageValue
      dosageUnit
      totalAdministeredQuantity
    }
  }
}
    `;

/**
 * __useGetInpatientInvestigationsMedicinesQuery__
 *
 * To run a query within a React component, call `useGetInpatientInvestigationsMedicinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpatientInvestigationsMedicinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpatientInvestigationsMedicinesQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useGetInpatientInvestigationsMedicinesQuery(baseOptions: Apollo.QueryHookOptions<GetInpatientInvestigationsMedicinesQuery, GetInpatientInvestigationsMedicinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpatientInvestigationsMedicinesQuery, GetInpatientInvestigationsMedicinesQueryVariables>(GetInpatientInvestigationsMedicinesDocument, options);
      }
export function useGetInpatientInvestigationsMedicinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpatientInvestigationsMedicinesQuery, GetInpatientInvestigationsMedicinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpatientInvestigationsMedicinesQuery, GetInpatientInvestigationsMedicinesQueryVariables>(GetInpatientInvestigationsMedicinesDocument, options);
        }
export type GetInpatientInvestigationsMedicinesQueryHookResult = ReturnType<typeof useGetInpatientInvestigationsMedicinesQuery>;
export type GetInpatientInvestigationsMedicinesLazyQueryHookResult = ReturnType<typeof useGetInpatientInvestigationsMedicinesLazyQuery>;
export type GetInpatientInvestigationsMedicinesQueryResult = Apollo.QueryResult<GetInpatientInvestigationsMedicinesQuery, GetInpatientInvestigationsMedicinesQueryVariables>;